module.exports = { id: "youtube", url: "/build/app/img/symbols.svg#youtube", viewBox: "", toString: function() { return this.url; } };